import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import itData from "../i18n/it.json";

// Thank you page: Italian-only, standalone (no Header/Footer layout dependency on lang param).
export default function ThankYou() {
  const t = itData.thankyou;
  useEffect(() => {
    document.title = "Grazie — Ecominiere";
    document.documentElement.lang = "it";
  }, []);
  return (
    <div className="ec-thankyou">
      <div className="ec-thankyou-card">
        <div className="ec-thankyou-check"><CheckCircle2 size={44} /></div>
        <span className="ec-eyebrow">{t.eyebrow}</span>
        <h1 className="ec-h1">{t.title}</h1>
        <p className="ec-lead">{t.body}</p>
        <div className="ec-thankyou-next">
          <h3>{t.next_title}</h3>
          <p>{t.next_body}</p>
        </div>
        <Link to="/" className="ec-btn ec-btn--primary">
          <ArrowLeft size={16} /> <span>{t.back}</span>
        </Link>
      </div>
    </div>
  );
}
